import { render, staticRenderFns } from "./PrevOptimize.vue?vue&type=template&id=65b77c0e&scoped=true"
import script from "./PrevOptimize.vue?vue&type=script&lang=js"
export * from "./PrevOptimize.vue?vue&type=script&lang=js"
import style0 from "./PrevOptimize.vue?vue&type=style&index=0&id=65b77c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b77c0e",
  null
  
)

export default component.exports